import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { Link } from '@tanstack/react-router'
import React from 'react'

interface NotFoundProps {
  title?: string
  description?: string
  buttonText?: string
  buttonLink?: string
}

export default function NotFound({
  title = 'No shared sessions',
  description = 'Sessions shared with you will appear here.',
  buttonText = 'Browse Community',
  buttonLink: _buttonLink = '#',
}: NotFoundProps) {
  return (
    <main className="flex h-[calc(100vh-180px)] items-center justify-center">
      <div className="flex flex-col items-center gap-2 text-center">
        <Icon name="layout-grid" className="text-muted-foreground h-5 w-5" />

        <h2 className="text-foreground mt-1 text-lg">{title}</h2>
        <p className="text-muted-foreground">{description}</p>

        {buttonText &&
          (_buttonLink && _buttonLink !== '#' ? (
            <Link to={_buttonLink}>
              <Button variant="default" size="sm" className="mt-4">
                {buttonText}
              </Button>
            </Link>
          ) : (
            <Button variant="default" size="sm" className="mt-4">
              {buttonText}
            </Button>
          ))}
      </div>
    </main>
  )
}
